import { GlobalStyles } from 'tss-react'
import { ReactNode } from 'react'
import 'normalize.css'

type StyleProps = {
  children: ReactNode
}

export const Styles = ({ children }: StyleProps) => {
  return (
    <>
      <GlobalStyles
        styles={`
                    @font-face {
            font-family: 'Inter';
            src: url('assets/fonts/Inter-Regular.woff2') format('woff2'),
            font-weight: 400;
            font-style: normal;
            font-display: swap;
          }
          body {
  user-select: none;
  -webkit-user-select: none; /* Chrome, Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* Internet Explorer/Edge */
  user-select: none;         /* Standard */
  overflow: hidden;
  overscroll-behavior: none;
  height: 100%;
}
  #root {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    min-height: 100%;
  }
          img {
    -webkit-touch-callout: none;
    -webkit-user-select: none;  
    -khtml-user-select: none;   
    -moz-user-select: none;      
    -ms-user-select: none;       
    user-select: none;          
    pointer-events: none;
}
          * {text-wrap: pretty; box-sizing: border-box; font-family: "inter", sans-serif; -ms-overflow-style: none; scrollbar-width: none;}, *::-webkit-scrollbar{display: none}`}
      />
      {children}
    </>
  )
}
